<template>
  <div class="hoist-tabs">
    <template>
      <el-backtop :bottom="80"></el-backtop>
    </template>
    <van-nav-bar
      class="topBar"
      v-if="!isMobile"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tabs">
      <WorkCollect v-if="activeName === 0" />
      <DetailList v-if="activeName === 1" />
      <van-tabbar v-model="activeName">
        <van-tabbar-item icon="home-o">任务汇总</van-tabbar-item>
        <van-tabbar-item icon="friends-o">明细列表</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import WorkCollect from './WorkCollect'
import DetailList from './DetailList'
import { Tabbar, TabbarItem, NavBar } from 'vant'
export default {
  components: {
    WorkCollect,
    DetailList,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [NavBar.name]: NavBar
  },
  data() {
    return {
      activeName: 0,
      isMobile: false
    }
  },
  mounted() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 检测是否手机端
      this.isMobile = true
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    onClickLeft() {
      this.$router.push({
        path: '/mobile'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hoist-tabs {
  background-color: #ececec70;
  height: 100vh;
  .tabs {
    background-color: #fff;
    height: calc(100vh - 30px);
  }
}
.van-tabbar {
  z-index: 10;
}
</style>